<!-- 支付完成跳转页面 -->

<template>
    <div>
        loading....
    </div>
</template>

<script>
    import allEventLog from '../../utils/allEventLog'

    export default {
        name: 'Jump',
        mounted() {
            let params = this.$route.query;
            let payJump_urlData , payJump_orderSn;

            // 记录收银台返回的数据
            params.localOrderInfo = window.localStorage.getItem('localOrderInfo') || '';
            if(params.localOrderInfo){
                try{
                   payJump_urlData = JSON.parse(localStorage.localOrderInfo);
                   payJump_orderSn  = payJump_urlData && payJump_urlData.orderSn;
                }catch(e){
                    allEventLog.payLog('pay/jump', params, this);
                }
            }

            if(params.orderSn) {                
                params.HasOrderSn = true;
            } else {
                params.UnOrderSn = true;
            }
            allEventLog.payLog('pay/jump', params, this);
            window.localStorage.removeItem('localOrderInfo');

            // oriResultCode  orderSn  busiReturnUrl
            // payResult ==> FINISH、SUCCESS、CANCEL、FAILURE、HASPAID=》已支付
            if(['SUCCESS','FINISH','HASPAID'].includes(params.payResult)) {
                this.$router.push(this.$setRouteQuery({
                    name: 'PayResult',
                    query: {
                        orderSn: params.orderSn || payJump_orderSn
                    }
                },this));
            } else {
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                if(urlData.sn){
                    this.$router.push({
                        name: 'DigitalList'
                    });
                } else {
                    this.$router.push(this.$setRouteQuery({
                        name: 'Home'
                    },this));
                }
            }
        }
    }
</script>